import { createBrowserHistory } from 'history'

export enum Routes {
	LOGIN = '/login',
	COMMON_PROJECTS = '/common-projects',
	COMMON_PROJECTS_PARAMETERS = '/common-projects/project/:id/parameters',
	COMMON_PROJECTS_RATES = '/common-projects/project/:id/rates',
	COMMON_PROJECTS_CONSTRUCTION_RESOURCES = '/common-projects/project/:id/construction-resources',
	COMMON_PROJECTS_TECHNICAL_SOLUTIONS = '/common-projects/project/:id/technical-solutions',

	USER_PROJECTS = '/user-projects',
	USER_PROJECTS_PROJECT = '/user-projects/project/:id',
	USER_PROJECTS_PARAMETERS = '/user-projects/project/:id/parameters',
	USER_PROJECTS_RATES = '/user-projects/project/:id/rates',
	USER_PROJECTS_TECHNICAL_SOLUTIONS = '/user-projects/project/:id/technical-solutions',
  USER_PROJECTS_RPC = '/user-projects/project/:id/rpc',
  
	USER_ARCHIVE = '/user-archive',
	USER_ARCHIVE_PROJECT = '/user-archive/project/:id',
	USER_ARCHIVE_PARAMETERS = '/user-archive/project/:id/parameters',
	USER_ARCHIVE_RATES = '/user-archive/project/:id/rates',
	USER_ARCHIVE_TECHNICAL_SOLUTIONS = '/user-archive/project/:id/technical-solutions',

	ADMIN = '/admin',
	ADMIN_USERS = '/admin/users',
	ADMIN_COMPANIES = '/admin/companies',
	ADMIN_SETTINGS = '/admin/settings',
	ADMIN_SOLUTIONS = '/admin/solutions',
	OBJECTS_ANALOG = '/admin/objects-analog',

	PERSONAL_AREA = '/personal-area',

	FAVORITES_COMMON_PROJECTS = '/favorites-common-projects',
	FAVORITES_PURCHASES = '/favorites-purchases',

	INVESTMENT_PROGRAMS = '/ipr',
	DEVELOPMENT_SCHEMES_AND_PROGRAMS = '/sipr',

	PURCHASES = '/purchases',
	PURCHASES_PROJECT = '/purchases/project/:id',
	PURCHASES_DETAIL = `/purchases/:type/:id`,
	PURCHASES_PROJECT_INVESTITION = '/purchases/project/:id/investition',

	ADMIN_INVESTMENT_PROGRAMS = '/admin/ipr',
	ADMIN_EDIT_INVESTMENT_PROGRAM = '/admin/ipr/:id',
	ADMIN_CREATE_INVESTMENT_PROGRAM = '/admin/ipr/create',
	ADMIN_DEVELOPMENT_SCHEMES_AND_PROGRAMS = '/admin/sipr',
	ADMIN_EDIT_DEVELOPMENT_SCHEME_AND_PROGRAM = '/admin/sipr/:id',
	ADMIN_CREATE_DEVELOPMENT_SCHEME_AND_PROGRAM = '/admin/sipr/create',
}

export const history = createBrowserHistory()
